
export default [

        {
            path:'/maggzine',
            name:'maggzine',
            component:() => import('@/views/maggzine/maggzine'),
            meta: {
    
                keepAlive: true, //此组件需要被缓存
                isBack:false,
    
            }
        },
        
        {
            path:'/maggzine_histroy',
            name:'maggzine_histroy',
            component:() => import('@/views/maggzine/maggzine_histroy'),
            meta: {
    
                keepAlive: true, //此组件需要被缓存
                isBack:false,
            }
        },
        {
            path:'/maggzine_info',
            name:'maggzine_info',
            component:() => import('@/views/maggzine/maggzine_info'),
            meta: {
    
                keepAlive: true, //此组件需要被缓存
                isBack:false,
            }
        },
        {
            path:'/maggzine_detail',
            name:'maggzine_detail',
            component:() => import('@/views/maggzine/maggzine_detail'),
            meta: {
    
                keepAlive: false, //此组件需要被缓存
    
            }
        },
]


// WEBPACK FOOTER //
// ./src/router/maggzine.js